<template>
  <v-container fluid justify-center class="pa-0">
    <v-card>
      <v-card-text :class="appColor_Medium">
        <v-row justify="center" class="my-3">
          <span class="grey--text text--lighten-3 headline">
            <template>
              <span>Redirecting to Ambient Access...</span>
            </template>
          </span>
        </v-row>
        </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { AppColor } from '@/config.js'

// redirect from auth0 will look like this (shrug)
// http://aatadmin.com/Authorize/?iss=https%3A%2F%2F%ambientactivity.us.auth0.com%2F

export default {
  name: 'Authorize',
  data() {
    return {
      appColor_Medium: AppColor.Medium
    }
  },
  computed: {
    isAuth0Client () {
      return this.$auth.auth0Client !== null
    }
  },
  methods: {
    async signIn () {
      this.drawer = false
      await this.$auth.loginWithRedirect()
    }
  },
  watch: {
    isAuth0Client (val) {
      if (val) {
        // if (this.$route.query.iss !== undefined) {
        //   const iss = this.$route.query.iss
        //   console.log(iss)
        // }
        this.signIn()
      }
    }
  }
}

</script>